import { Check } from '@material-ui/icons'

export default (props) => <Check htmlColor='#4CAF50' {...props} />
